import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { Special } from '../../../types/specials';
import { fetchSpecials } from '../../../services/specials';
import { usePages } from '../../../hooks/usePages';
import { useFlash } from '../../../hooks/useFlash';

const PAGINATE_PER = 20;

type Props = {
  flash?: boolean;
  flashType?: string;
  flashMessage?: string;
};

export const Component: FunctionComponent<Props> = (props) => {
  const [specials, setSpecials] = useState<Special[]>([]);
  const [isLoading, setIsLoading ] = useState(true);

  const {
    page,
    handlePageChange,
    shouldShowPagination,
    paginatedItems: paginatedSpecials
  } = usePages(specials, PAGINATE_PER);

  const { flash, flashType, flashMessage, handleFlash } = useFlash();

  useEffect(() => {
    const fetchSpecialsData = async () => {
      try {
        const response = await fetchSpecials();
        setSpecials(response.specials);
      } catch (e) {
        console.error("Failed to fetch specials:", e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSpecialsData();
    if (props.flash) {
      handleFlash(props.flash, props.flashType ?? '', props.flashMessage ?? '');
    }
  }, []);

  return (
    <Presentation
      specials={paginatedSpecials}
      specialsCount={specials.length}
      isLoading={isLoading}
      currentPage={page}
      paginatePer={PAGINATE_PER}
      shouldShowPagination={shouldShowPagination}
      onPageChange={handlePageChange}
      flash={flash}
      flashType={flashType}
      flashMessage={flashMessage}
      handleFlash={handleFlash}
    />
  );
};
